import { render } from "./BaseEmptyProductState.vue?vue&type=template&id=790bbcca&scoped=true"
import script from "./BaseEmptyProductState.vue?vue&type=script&lang=js"
export * from "./BaseEmptyProductState.vue?vue&type=script&lang=js"

import "./BaseEmptyProductState.vue?vue&type=style&index=0&id=790bbcca&scoped=true&lang=scss"

import exportComponent from "/opt/render/project/src/node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-790bbcca"]])

export default __exports__